var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-message-box boss-message-box-received",
      class: { "boss-message-box-can-send": _vm.canSendMessage },
    },
    [
      _c("img", {
        staticClass: "boss-message-box-avatar boss-message-box-avatar-user",
        attrs: { src: require("@/assets/images/boss-avatar.svg") },
      }),
      _vm._v(" "),
      _c("entry-message-history-message-detail", {
        attrs: { date: _vm.date, subject: _vm.subject, body: _vm.body },
      }),
      _vm._v(" "),
      _vm.canSendMessage
        ? _c("div", { staticClass: "boss-message-last-button-block" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.tooltip,
                    expression: "tooltip",
                  },
                ],
                staticClass: "boss-button pega-button",
                attrs: {
                  href: "javascript:void(0)",
                  "data-test": "quote-message",
                  disabled: _vm.isReserved || _vm.isWithdraw,
                },
                on: { click: _vm.setMessage },
              },
              [_vm._v("\n      メッセージを引用してメールを作成\n    ")]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }